import script from "./Terms.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms.vue?vue&type=script&setup=true&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=2033a554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2033a554"]])

export default __exports__